/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Goal_PickInputs */

const en_portal_goal_pick = /** @type {(inputs: Portal_Goal_PickInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pick a goal`)
};

const pl_portal_goal_pick = /** @type {(inputs: Portal_Goal_PickInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wybierz cel`)
};

/**
* | output |
* | --- |
* | "Pick a goal" |
*
* @param {Portal_Goal_PickInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_goal_pick = /** @type {((inputs?: Portal_Goal_PickInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Goal_PickInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_goal_pick(inputs)
	return en_portal_goal_pick(inputs)
});